// src/components/ailab-chat/ChatWindow.js

import React, { useRef, useEffect } from 'react';
import ChatInput from './ChatInput';
import MessageBubble from './MessageBubble';
import { LoadingDots } from './icons';
import { ArrowLeft } from 'lucide-react'; // Import Arrow icon

const ChatWindow = ({ persona, messages, isLoading, onSendMessage, onBack }) => {
  const messagesEndRef = useRef(null);
  const prevMessagesLengthRef = useRef(0);

  useEffect(() => {
    // Only auto-scroll when a NEW message is added (not on every render)
    // This allows users to scroll up and read previous messages
    if (messages.length > prevMessagesLengthRef.current) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    prevMessagesLengthRef.current = messages.length;
  }, [messages]);

  if (!persona) {
    return (
        <div className="chat-window-welcome">
            <h2>Welcome to AI Lab Quant Chat</h2>
            <p>Select an AI expert from the left to start a conversation.</p>
        </div>
    );
  }

  return (
    <div className="chat-window">
      <header className="chat-window-header">
        {/* BACK BUTTON - Visible on Mobile Only via CSS */}
        <button 
            className="chat-back-button md:hidden" 
            onClick={onBack}
            aria-label="Back to experts list"
        >
            <ArrowLeft size={20} />
        </button>

        <img
          src={persona.avatarUrl}
          alt={persona.koruName}
          className="persona-avatar"
        />
        <div className="chat-header-info">
          <h2 className="persona-info-name">{persona.koruName}</h2>
          <p className="persona-info-handle">{persona.handle}</p>
        </div>
      </header>
      
      <main className="chat-window-main">
        {messages.map((msg) => (
          <MessageBubble key={msg.id} message={msg} />
        ))}
        {isLoading && (
          <div className="message-bubble-container ai">
            <img src={persona.avatarUrl} alt={persona.koruName} className="message-bubble-avatar" />
            <div className="message-bubble-content ai">
              <LoadingDots />
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </main>

      <ChatInput onSendMessage={onSendMessage} isLoading={isLoading} />
    </div>
  );
};

export default ChatWindow;